<template>
  <div class="category-create">
    <!-- 创建表单 -->
    <el-form ref="categoryForm" :model="formData" label-width="120px" label-position="right" size="medium">
      <!-- 类别编号 -->
      <el-form-item label="类别编号" prop="class_no">
        <el-input style="width: 300px;" :disabled="!create" v-model="formData.class_no" placeholder="请输入类别编号" clearable
          maxlength="10" show-word-limit />
      </el-form-item>

      <!-- 类别名称 -->
      <el-form-item label="类别名称" prop="class_name">
        <el-input style="width: 300px;" v-model="formData.class_name" placeholder="请输入类别名称" clearable maxlength="20"
          show-word-limit />
      </el-form-item>

      <!-- 标准类别编号 -->
      <el-form-item label="标准类别编号" prop="standard_class_no">
        <el-select style="width: 300px;" filterable v-model="formData.standard_class_no" placeholder="关联系的统分类">
          <el-option v-for="item in allPrimaryClassList" :key="item.class_no" :label="item.class_name"
            :value="item.class_no">
          </el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="类别图标" prop="create_no">
        <dyhUpload @dyhUploadReturn="dyhUploadReturn" ref="dyhUploadRef" :count="1"></dyhUpload>
      </el-form-item>

      <!-- 表单按钮 -->
      <el-form-item class="form-buttons">
        <el-button type="primary" @click="handleSubmit" :loading="submitting">
          {{ create ? '创建类别' : '保存修改' }}
        </el-button>
        <el-button @click="handleReset">重置</el-button>
        <el-button @click="handleCancel">取消</el-button>
      </el-form-item>
    </el-form>

  </div>
</template>

<script>
import { getClassifyList } from '@/api/basic.js';
import { onlinesClassifyCreate, onlinesClassifyUpdate } from '@/api/onlines/goods';
import dyhUpload from '@/components/dyhUpload.vue';
export default {
  name: 'classify',
  components: {
    dyhUpload
  },
  data() {
    // 自定义验证规则示例
    const validateClassNo = (rule, value, callback) => {
      if (value && !/^[A-Za-z0-9_-]+$/.test(value)) {
        callback(new Error('类别编号只能包含字母、数字、下划线和连字符'))
      } else {
        callback()
      }
    }

    return {
      // 表单数据
      formData: {
        class_no: '',
        class_name: '',
        standard_class_no: '',
        image: ""
      },
      create: true,
      // 表单验证规则
      formRules: {
        class_no: [
          { required: true, message: '请输入类别编号', trigger: 'blur' },
          { min: 2, max: 50, message: '长度在 2 到 50 个字符', trigger: 'blur' },
          { validator: validateClassNo, trigger: 'blur' }
        ]
      },
      // 提交状态
      submitting: false,
      // 成功对话框显示状态
      successDialogVisible: false,
      allPrimaryClassList: [],
      classTreeList: [],
      imageList: []
    }
  },

  created() {
  },
  mounted() {
    this.getClassifyList();
  },
  methods: {
    /**
     * 上传图片接口返回
     */
    dyhUploadReturn(res) {
      if (res.imageList && res.imageList.length > 0) {
        if (res.imageList[0].media_no) {
          this.formData.image = res.imageList[0].media_no;
        } else {
          this.formData.image = res.imageList[0].url;
        }
      }
    },
    /**
     * 设置类别
     * @param d
     */
    setFormData(d) {
      this.formData = d;
      this.create = false;
      this.imageList = [];
      this.imageList.push(this.formData.url);
      this.$refs.dyhUploadRef.setBaseImage(this.imageList);
    },
    /**
     * 获取所有线上类别
     */
    async getClassifyList() {
      this.allPrimaryClassList = [];
      this.classTreeList = [];
      const res = await getClassifyList();
      this.allPrimaryClassList = res.allList;
      this.classTreeList = res.t2;
    },
    /**
     * 提交表单
     */
    handleSubmit() {
      const that = this;
      this.$refs.categoryForm.validate(async (valid) => {
        if (valid) {
          this.submitting = true;
          try {
            if (this.create) {
              // 设置时间戳
              const res = await onlinesClassifyCreate({ ...this.formData, url: "" });
              if (res.state === true) {
                that.successMessage(res.message || '类别创建成功');
                // 触发成功事件
                that.$emit('classDialogCancel', { state: res.state })
              } else {
                throw new Error(res.message || '创建失败，请重试')
              }
            } else {
              const result = await onlinesClassifyUpdate({ ...this.formData, url: "" });
              if (result.state === true) {
                this.successMessage(result.message);
                that.$emit('classDialogCancel', { state: result.state })
              }
            }
          } catch (error) {
            that.$message.error(error.message);
          } finally {
            that.submitting = false;
          }
        } else {
          that.$message.warning('请完善表单信息')
        }
      })
    },

    /**
     * 重置表单
     */
    handleReset() {
      this.$refs.categoryForm.resetFields();
      this.create = true;
    },

    /**
     * 取消创建
     */
    handleCancel() {
      this.$confirm('确定取消创建吗？未保存的数据将丢失', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$emit('classDialogCancel', { state: false })
      }).catch(() => { })
    },

    /**
     * 关闭成功对话框
     */
    handleSuccessDialogClose() {
      this.successDialogVisible = false
      // 重置表单以便继续创建
      this.handleReset()
    },

    /**
     * 查看详情
     */
    handleViewDetail() {
      this.successDialogVisible = false
      // 跳转到详情页或触发查看详情事件
      this.$emit('view-detail', { ...this.formData })
    },

    /**
     * 模拟API调用
     */
    mockApiCall() {
      return new Promise((resolve) => {
        setTimeout(() => {
          resolve({ success: true })
        }, 1000)
      })
    },

    /**
     * 格式化日期（示例工具函数）
     */
    formatDate(date) {
      if (!date) return ''
      //return formatDateTime(date)
    }
  }
}
</script>

<style scoped>
.category-create {
  padding: 20px;
  max-width: 800px;
  margin: 0 auto;
}

.create-card {
  margin-bottom: 20px;
}

.card-title {
  font-size: 16px;
  font-weight: 600;
  color: #303133;
}

.form-buttons {
  margin-top: 30px;
  text-align: center;
}

.success-content {
  text-align: center;
  padding: 20px 0;
}

.success-icon {
  font-size: 48px;
  color: #67C23A;
  margin-bottom: 15px;
}

.success-detail {
  color: #909399;
  font-size: 14px;
  margin-top: 10px;
}

/* 响应式调整 */
@media (max-width: 768px) {
  .category-create {
    padding: 10px;
  }

  .create-card {
    margin-bottom: 10px;
  }
}
</style>